<div class="mb-3" [class.opacity-50]="disabled" appDnd (fileDropped)="onFileDropped($event)">
    <label *ngIf="label" class="form-label" [class.asterisk-input]="isRequired">{{ label }}</label>
    <!-- Dropzone Mode -->
    <div *ngIf="isDropzone; else normalMode" class="file-dropzone" (click)="onSelect(native)">
        <input #native type="file" class="d-none" [accept]="accept" (change)="onFileChosen($event)" />
        <div *ngIf="!hasFile" class="text-center fw-bold">
            <i class="ri-upload-cloud-2-fill fs-1"></i>
            <p>Drop file here or click to upload</p>
        </div>
        <div *ngIf="hasFile" class="w-100 px-3">
            <div class="d-flex justify-content-between align-items-center">
                <div class="text-truncate me-3">
                    <i class="ri-file-line me-2"></i>
                    {{ fileName }}
                </div>
                <div class="d-flex gap-2">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="preview(); $event.stopPropagation()">
                        <i class="ri-eye-line"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="download(); $event.stopPropagation()">
                        <i class="ri-download-2-line"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="isDeletable"
                        (click)="remove(); $event.stopPropagation()">
                        <i class="ri-delete-bin-line"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Normal Mode -->
    <ng-template #normalMode>
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" [value]="fileName" [placeholder]="placeholder" readonly />
            <input #native type="file" class="d-none" [accept]="accept" (change)="onFileChosen($event)" />
            <button type="button" class="btn btn-outline-secondary" [disabled]="disabled" (click)="onSelect(native)">
                <i [class]="hasFile ? 'ri-eye-line' : 'ri-upload-2-line'"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary" [disabled]="disabled || !hasFile"
                (click)="download()">
                <i class="ri-download-2-line"></i>
            </button>
            <button type="button" class="btn btn-outline-danger" [disabled]="disabled || !hasFile" (click)="remove()">
                <i class="ri-delete-bin-line"></i>
            </button>
        </div>
    </ng-template>
    <div class="invalid-feedback d-block" *ngIf="hasError">
        <div *ngFor="let msg of errorMessages">{{ msg }}</div>
    </div>
</div>